import { CapacityItem, type CapacityItemProps } from "./CapacityItem";

export interface CapacityProps {
  capacityData: Array<CapacityItemProps>;
}

/**
 * Capacity component displays a list of capacity information items
 * 
 * @param capacityData - Array of capacity items containing type and title information
 */
export const Capacity = ({ capacityData }: CapacityProps) => {
  if (!capacityData?.length) {
    return null;
  }
  
  return (
    <div className="flex items-center justify-between grow-1">
      <div className="flex items-center gap-x-2">
        {capacityData.map((item, index) => (
          <CapacityItem
            key={item.title || index}
            type={item.type}
            title={item.title}
          />
        ))}
      </div>
    </div>
  );
};